import { call, put, takeLatest } from "redux-saga/effects";
import { hallsAPI } from "../api/api";
import { HallsActionTypes } from "../actions/actionTypes";
import { API } from "../../../api/api";

function* getSubsidiaries(action) {
    try {
        const subsidiaries = yield call(() => hallsAPI.getSubsidiaries());

        yield put({
            type: HallsActionTypes.GET_SUBSIDIARIES_SUCCESS,
            payload: {
                subsidiaries: subsidiaries.data
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error getting subsidiary list.");

        yield put({
            type: HallsActionTypes.GET_SUBSIDIARIES_FAIL,
            message: e.message
        });
    }
}

export function* getSubsidiariesWatcher() {
    yield takeLatest(HallsActionTypes.GET_SUBSIDIARIES, getSubsidiaries);
}

/* function* getCashSystems(action) {
    try {
        const cash_systems = yield call(() => hallsAPI.getCashSystems());

        yield put({
            type: HallsActionTypes.GET_CASH_SYSTEMS_SUCCESS,
            payload: {
                cash_systems: cash_systems.data
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error getting cash systems.");

        yield put({
            type: HallsActionTypes.GET_CASH_SYSTEMS_FAIL,
            message: e.message
        });
    }
} */

/* export function* getCashSystemWatcher() {
    yield takeLatest(HallsActionTypes.GET_CASH_SYSTEMS, getCashSystems);
} */

function* getCoreVersions(action) {
    try {
        const core_versions = yield call(() => hallsAPI.getCoreVersions());

        yield put({
            type: HallsActionTypes.GET_CORE_VERSIONS_SUCCESS,
            payload: {
                core_versions: core_versions.data
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error getting core versions.");

        yield put({
            type: HallsActionTypes.GET_CORE_VERSIONS_FAIL,
            message: e.message
        });
    }
}

export function* getCoreVersionsWatcher() {
    yield takeLatest(HallsActionTypes.GET_CORE_VERSIONS, getCoreVersions);
}

function* getTimezones(action) {
    try {
        const timezones = yield call(() =>
            hallsAPI.getTimezones(action.payload.subsidiaryCountry)
        );

        yield put({
            type: HallsActionTypes.GET_TIMEZONES_SUCCESS,
            payload: {
                timezones: timezones.data
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error getting country timezones.");

        yield put({
            type: HallsActionTypes.GET_TIMEZONES_FAIL,
            message: e.message
        });
    }
}

export function* getTimezonesWatcher() {
    yield takeLatest(HallsActionTypes.GET_TIMEZONES, getTimezones);
}

function* getDynamicHall(action) {
    try {
        const halls = yield call(() =>
            hallsAPI.getDynamicHall(action.payload.subsidiary)
        );
        yield put({
            type: HallsActionTypes.GET_DYNAMIC_HALL_SUCCESS,
            payload: {
                halls: halls.data
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error getting subsidiary dynamic hall.");

        yield put({
            type: HallsActionTypes.GET_DYNAMIC_HALL_FAIL,
            message: e.message
        });
    }
}

export function* getDynamicHallWatcher() {
    yield takeLatest(HallsActionTypes.GET_DYNAMIC_HALL, getDynamicHall);
}

function* getDynamicHallInfo(action) {
    try {
        const hall = yield call(() =>
            hallsAPI.getDynamicHallInfo(action.payload.hallCode)
        );
        yield put({
            type: HallsActionTypes.GET_DYNAMIC_HALL_INFO_SUCCESS,
            payload: {
                hall: hall.data
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error getting subsidiary dynamic hall.");

        yield put({
            type: HallsActionTypes.GET_DYNAMIC_HALL_INFO_FAIL,
            message: e.message
        });
    }
}

export function* getDynamicHallInfoWatcher() {
    yield takeLatest(HallsActionTypes.GET_DYNAMIC_HALL_INFO, getDynamicHallInfo);
}